module.exports = __webpack_public_path__ + "../resources/images/SkyCode_12-ea89d360e4d0224c4d91085ada3e6db0.svg";